import { render } from "./TheAlerts.vue?vue&type=template&id=6c2e75af&scoped=true"
import script from "./TheAlerts.vue?vue&type=script&lang=js"
export * from "./TheAlerts.vue?vue&type=script&lang=js"

import "./TheAlerts.vue?vue&type=style&index=0&id=6c2e75af&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/asgard/asgard-frontend/asgard_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2e75af"]])

export default __exports__